import SmartEditor from "./SmartEditor";

export default SmartEditor;
